import {PayloadAction} from "../payload-action.interface";
import {ProtocolEntity} from "./protocol.entity";

export class ProtocolActions {
  static readonly ADD =     '[ProtocolActions] ADD';
  static readonly REMOVE =  '[ProtocolActions] REMOVE';
  static readonly SET =     '[ProtocolActions] SET';

  static add(protocol: ProtocolEntity): PayloadAction {
    return {
      type: ProtocolActions.ADD,
      payload: protocol
    }
  }

  static set(protocol: ProtocolEntity): PayloadAction {

    return {
      type: ProtocolActions.SET,
      payload: protocol
    }
  }

  static remove(id: string): PayloadAction {
    return {
      type: ProtocolActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/protocol/protocol.actions.ts